import { GRID, AXIS, LABEL } from './chartColors.js';

// T341 — the quantitative y-axis, once.
//
// BarChart and LineChart drew the same eight lines each: the same <g key>, the
// same `t === 0 ? AXIS : GRID` (the baseline is an axis, every other tick is a
// gridline), the same crispEdges, the same right-aligned label four pixels into
// the gutter. They differed only in `padLeft` — 26 against 30, for no reason
// either file gives — and in whether the tick formatter was optional.
//
// Two correct copies are not a bug today; they are the thing that makes the
// next change to tick typography land in one chart and not the other. The kit's
// whole premise is that two bars on the same screen cannot be different
// colours, and an axis is no different.

/**
 * @param {number[]} ticks   tick values, already chosen by niceTicks
 * @param {(t:number)=>number} yOf   value → pixel y
 * @param {number} padLeft   the label gutter the caller reserved
 * @param {number} width     full chart width; lines run to its right edge
 * @param {(t:number)=>string|number} [tickText]  formatter; identity by default
 */
export default function Axis({ ticks, yOf, padLeft, width, tickText }) {
  if (!ticks?.length) return null;
  return (
    <>
      {ticks.map((t) => (
        <g key={`t${t}`}>
          {/* The baseline is the axis; everything above it is a gridline. Same
              rule both charts already used, kept literally. */}
          <line
            x1={padLeft}
            x2={width}
            y1={yOf(t)}
            y2={yOf(t)}
            stroke={t === 0 ? AXIS : GRID}
            strokeWidth="1"
            shapeRendering="crispEdges"
          />
          <text x={padLeft - 4} y={yOf(t) + 3} textAnchor="end" fontSize="9" fill={LABEL}>
            {tickText ? tickText(t) : t}
          </text>
        </g>
      ))}
    </>
  );
}
